module.exports = "<ng-content></ng-content>\n<td *ngIf=\"state\">\n    <div class=\"spinner-block\"\n         [style.width.px]=\"width\"\n         [style.height.px]=\"height * rowCount\"\n         [style.left.px]=\"-width\">\n        <ui-spinner [show]=\"state\"></ui-spinner>\n    </div>\n</td>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/utils/ui-elements/ui-table-multirow-spinner/ui-spinner.html
// module id = 1070
// module chunks = 3